import Vue from 'vue'
import Router from 'vue-router'
import index from '@/components/index'
//投诉详情页面
import complain from '@/components/pub-component/complain/complain'
import complainList from '@/components/pub-component/complain/complainList'
import complainDetails from '@/components/pub-component/complain/complainDetails'
//报修
import repair from '@/components/pub-component/repair/repair'
import repairDetails from '@/components/pub-component/repair/repairDetails'//报修详情页面
//缴费
import pay from '@/components/pub-component/pay/pay'
import payList from '@/components/pub-component/pay/payList'
import payment from '@/components/pub-component/pay/payment'
import paymentDetail from '@/components/pub-component/pay/paymentDetail'//缴费详情页面
//我的
import checkTel from '@/components/pub-component/my/checkTel'
import checkTel1 from '@/components/pub-component/my/checkTel1'
import houseInfo from '@/components/pub-component/my/houseInfo'
import my from '@/components/pub-component/my/my'
import personInfo from '@/components/pub-component/my/personInfo'
//移动验房
import customerSignature from '../components/pub-component/mobile-home/customer-signature'//客户签字
import problemInput from '../components/pub-component/mobile-home/problem-input'//验房问题描述
import homeInspectionApplication from '../components/pub-component/mobile-home/home-inspection-application'//验房记录
import mobileHomeInspection from '../components/pub-component/mobile-home/mobile-home-inspection'
//装修申请
import decorationApp from '@/components/pub-component/decoration/decorationApp'
import decorationList from '@/components/pub-component/decoration/decorationList'
//我的管家
import myManager from '@/components/pub-component/myManager/evaluteManager' //我的管家
//公共
import evaluate from '@/components/son/evaluate'//评价页面
import homePage from '@/components/homePage'
import homePageXinYuan from '@/components/xinyuan/homePage-xinyuan'
import payXinYuan from '@/components/xinyuan/pay-xinyuan'
import homePageBeiKong from '../components/beikong/homePage-beikong'

// 新版微信  首页-公告列表页--公告详情页
import homePageMingSheng from '@/components/mingsheng/homePage-mingsheng'
import announce from '@/components/mingsheng/announce'
import announceDetail from '@/components/mingsheng/announceDetail'
//天恒锐创 首页
import homePageTianHeng from '@/components/tianheng/homePage-tianheng'
//北大资源
import homePageBeiDaZiYuan from '@/components/beidaziyuan/homePage-bdzy'
import checkTelBeiDaZiYuan from '@/components/beidaziyuan/checkTel-bdzy'
// 万通物业
import homePageWanTong from '@/components/wanTong/homePage-wanTong'

//鑫源的另一个公众号首页 青檬公寓
import homePageQingMeng from '@/components/xinyuan/homePage-qingMeng'
// 鑫源的投诉
import complainListQingMeng from '@/components/xinyuan/complainList'   // 青柠的投诉建议记录
import complainQingMeng from '@/components/xinyuan/complain'          // 青柠的投诉单 和建议类似 上报。
import myQingMeng from '@/components/xinyuan/my'                  // 服务记录主页我的
import BxComplain from '@/components/xinyuan/BxComplain'         // 报修记录
import repairQingMeng from '@/components/xinyuan/repair-qingMeng'          // 选择报修类型，公区还是住宅
import adViseComlain from '@/components/xinyuan/adViseComlain'          // 建议上报  (细节详情没有单独拉出)
// 鑫源首页添加投诉
import myXinYuan from '@/components/xinyuan/my-xinyuan'                  // 鑫源服务记录主页我的

Vue.use(Router)


export default new Router({
	mode:'history',
  routes: [
    {path: '/',
      name: 'index',
      component: index,
      },
    { path: '/mobileHomeInspection',
      name: 'mobileHomeInspection',
      component: mobileHomeInspection,
      beforeEnter (to, from, next) {
        document.getElementById('titleId').innerHTML = '移动验房'
        next()
      }
    },
    { path: '/customerSignature',
      name: 'customerSignature',
      component: customerSignature,
      beforeEnter (to, from, next) {
        document.getElementById('titleId').innerHTML = '客户签字'
        next()
      }
    },
    { path: '/problemInput',
      name: 'problemInput',
      component: problemInput,
      beforeEnter (to, from, next) {
        document.getElementById('titleId').innerHTML = '上报问题'
        next()
      }
    },
    { path: '/homeInspectionApplication',
      name: 'homeInspectionApplication',
      component: homeInspectionApplication,
      beforeEnter (to, from, next) {
        document.getElementById('titleId').innerHTML = '验房记录'
        next()
      }
    },
    { path: '/homePage',
      name: 'homePage',
      component: homePage,
      beforeEnter (to, from, next) {
        document.getElementById('titleId').innerHTML = '首页'
        next()
      }
     },
    { path: '/homePageQingMeng',
      name: 'homePageQingMeng',
      component: homePageQingMeng,
      beforeEnter (to, from, next) {
        document.getElementById('titleId').innerHTML = '首页'
        next()
      }
    },
    { path: '/homePageBeiDaZiYuan',
      name: 'homePageBeiDaZiYuan',
      component: homePageBeiDaZiYuan,
      beforeEnter (to, from, next) {
        document.getElementById('titleId').innerHTML = '首页'
        next()
      }
     },
    { path: '/homePageWanTong',
      name: 'homePageWanTong',
      component: homePageWanTong,
      beforeEnter (to, from, next) {
        document.getElementById('titleId').innerHTML = '首页'
        next()
      }
    },
    {path: '/checkTelBeiDaZiYuan',
      name: 'checkTelBeiDaZiYuan',
      component: checkTelBeiDaZiYuan
    },
    {path: '/homePageTianHeng',
      name: 'homePageTianHeng',
      component: homePageTianHeng,
      beforeEnter (to, from, next) {
        document.getElementById('titleId').innerHTML = '首页'
        next()
      }
     },
    {path: '/homePageMingSheng',
      name: 'homePageMingSheng',
      component: homePageMingSheng,
      beforeEnter (to, from, next) {
        document.getElementById('titleId').innerHTML = '首页'
        next()
      }
     },
    {path: '/announce',
      name: 'announce',
      component: announce,
      beforeEnter (to, from, next) {
        document.getElementById('titleId').innerHTML = '公告'
        next()
      }
     },
    {path: '/announceDetail',
      name: 'announceDetail',
      component: announceDetail,
      beforeEnter (to, from, next) {
        document.getElementById('titleId').innerHTML = '公告详情'
        next()
      }
     },
    {path: '/decorationApp',
      name: 'decorationApp',
      component: decorationApp,
      beforeEnter (to, from, next) {
        document.getElementById('titleId').innerHTML = '装修申请'
        next()
      }
     },
    {path: '/decorationList',
      name: 'decorationList',
      component: decorationList,
      beforeEnter (to, from, next) {
        document.getElementById('titleId').innerHTML = '我的装修申请'
        next()
      }
     },
    {path: '/myManager',
      name: 'myManager',
      component: myManager,
      beforeEnter (to, from, next) {
        document.getElementById('titleId').innerHTML = '我的管家'
        next()
      }
     },
    {path: '/homePageXinYuan',
      name: 'homePageXinYuan',
      component: homePageXinYuan,
      beforeEnter (to, from, next) {
        document.getElementById('titleId').innerHTML = '首页'
        next()
      }
    },
    {path: '/homePageBeiKong',
      name: 'homePageBeiKong',
      component: homePageBeiKong,
      beforeEnter (to, from, next) {
        document.getElementById('titleId').innerHTML = '首页'
        next()
      }
    },
    {path: '/complain',
      name: 'complain',
      component: complain,
       beforeEnter (to, from, next) {
        document.getElementById('titleId').innerHTML = '建议'
        next()
      }
    },
    {path: '/repair',
      name: 'repair',
      component: repair,
      beforeEnter (to, from, next) {
        document.getElementById('titleId').innerHTML = '报修'
        next()
      } },
    {path: '/my',
      name: 'my',
      component: my,
      beforeEnter (to, from, next) {
        document.getElementById('titleId').innerHTML = '我的'
        next()
      } },
    {path: '/pay',
      name: 'pay',
      component: pay,
      beforeEnter (to, from, next) {
        document.getElementById('titleId').innerHTML = '缴费'
        next()
      } },
    {path: '/pay-xinyuan',
      name: 'payXinYuan',
      component: payXinYuan,
      beforeEnter (to, from, next) {
        document.getElementById('titleId').innerHTML = '缴费'
        next()
      } },
    {path: '/payList',
      name: 'payList',
      component: payList,
      beforeEnter (to, from, next) {
        document.getElementById('titleId').innerHTML = '缴费记录'
        next()
      } },
    {path: '/personInfo',
      name: 'personInfo',
      component: personInfo,
      beforeEnter (to, from, next) {
        document.getElementById('titleId').innerHTML = '个人信息'
        next()
      } },
    {path: '/checkTel',
      name: 'checkTel',
      component: checkTel
    },
    {path: '/checkTel1',
      name: 'checkTel1',
      component: checkTel1
    },
    {path: '/houseInfo',
      name: 'houseInfo',
      component: houseInfo,
      beforeEnter (to, from, next) {
        document.getElementById('titleId').innerHTML = '房产信息'
        next()
      } },
       {path: '/complainList',
      name: 'complainList',
      component: complainList,
      beforeEnter (to, from, next) {
        document.getElementById('titleId').innerHTML = '服务记录'
        next()
      } },
    {path: '/complainListQingMeng',
      name: 'complainListQingMeng',
      component: complainListQingMeng,
      beforeEnter (to, from, next) {
        document.getElementById('titleId').innerHTML = '投诉建议记录'
        next()
      } },
    {path: '/complainQingMeng',
      name: 'complainQingMeng',
      component: complainQingMeng,
      beforeEnter (to, from, next) {
        document.getElementById('titleId').innerHTML = '投诉'
        next()
      } },
    {path: '/myQingMeng',
      name: 'myQingMeng',
      component: myQingMeng,
      beforeEnter (to, from, next) {
        document.getElementById('titleId').innerHTML = '服务记录'
        next()
      } },
    {path: '/myXinYuan',
      name: 'myXinYuan',
      component: myXinYuan,
      beforeEnter (to, from, next) {
        document.getElementById('titleId').innerHTML = '我的'
        next()
      } },
    {path: '/BxComplain',
      name: 'BxComplain',
      component: BxComplain,
      beforeEnter (to, from, next) {
        document.getElementById('titleId').innerHTML = '报修记录'
        next()
      } },
    {path: '/repairQingMeng',
      name: 'repairQingMeng',
      component: repairQingMeng,
      beforeEnter (to, from, next) {
        document.getElementById('titleId').innerHTML = '报修'
        next()
      } },
    {path: '/adViseComlain',
      name: 'adViseComlain',
      component: adViseComlain,
      beforeEnter (to, from, next) {
        document.getElementById('titleId').innerHTML = '建议'
        next()
      } },
//    {path: '/demo',
//    name: 'demo',
//    component: demo
//  },
       {path: '/payment',
      name: 'payment',
      component: payment,
      beforeEnter (to, from, next) {
        document.getElementById('titleId').innerHTML = '物业缴费'
        next()
      } },
       {path: '/paymentDetail',
      name: 'paymentDetail',
      component: paymentDetail,
      beforeEnter (to, from, next) {
        document.getElementById('titleId').innerHTML = '缴费详情'
        next()
      } },
       {path: '/repairDetails',
      name: 'repairDetails',
      component: repairDetails,
      beforeEnter (to, from, next) {
        document.getElementById('titleId').innerHTML = '报修详情'
        next()
      } },
       {path: '/repairDetails/evaluate',
      name: 'evaluate',
      component: evaluate,
      beforeEnter (to, from, next) {
        document.getElementById('titleId').innerHTML = '评价'
        next()
      } },
       {path: '/complainDetails',
      name: 'complainDetails',
      component: complainDetails,
      beforeEnter (to, from, next) {
        document.getElementById('titleId').innerHTML = '投诉详情'
        next()
      } }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js